<template>
    <div style="width: 100%;height: 100%;overflow: hidden">
      <div class="nothing-data" v-if="alarmLine.length === 0"></div>
      <div class="line" id="line" ref="line_wrap" v-else></div>
    </div>
</template>

<script>
export default {
  name: 'alarmLine',
  props: {
    alarmLine: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      alarm: {
        sos: [],
        smoke: [],
        gas: [],
        intrusion: [],
        water: [],
        health: []
      },
      dateArr: [],
      alarmLines: []
    }
  },
  created () {
    // 报警统计
    this.alarmLines = this.alarmLine
  },
  mounted () {
    this.golobleObject.kindAlarmLine = this.getmattAlarmLine
    this.getKindArr()
  },
  methods: {
    getRefresh (arr) {
      // console.log('报警趋势')
      this.alarmLines = arr
      this.alarm = {
        sos: [],
        smoke: [],
        gas: [],
        intrusion: [],
        water: [],
        health: []
      }
      this.getKindArr()
    },
    // 日期
    getAlarmDate () {
      const arr = []
      // eslint-disable-next-line no-extend-native
      Date.prototype.format = this.validate.format
      let time = new Date().getTime()
      arr.push(new Date().format('yyyy-MM-dd'))
      for (let i = 0; i < 6; i++) {
        time -= 86400000
        arr.unshift(new Date(time).format('yyyy-MM-dd'))
      }
      return arr
    },
    getmattAlarmLine (obj) {
      // console.log(111, obj)
      let sos = ['sub_keysos', 'sos', 'nonetwork24', 'outage', 'lowpower', 'phonein', 'remove']
      let smoke = ['nb-co', 'F-Fire', 'F-Test', 'sub_fire', 'sub_co', 'nb-co-test', 'sub_fire_test']
      let gas = ['sub_gas']
      let intrusion = ['sub_infrared', 'sub_opendoor']
      let water = ['sub_water']
      let health = ['heartbeat', 'falldown']
      if (sos.indexOf(obj.alarmtype) > -1) {
        this.alarm.sos[this.alarm.sos.length - 1] += 1
      } else if (smoke.indexOf(obj.alarmtype) > -1) {
        this.alarm.smoke[this.alarm.smoke.length - 1] += 1
      } else if (gas.indexOf(obj.alarmtype) > -1) {
        this.alarm.gas[this.alarm.gas.length - 1] += 1
      } else if (intrusion.indexOf(obj.alarmtype) > -1) {
        this.alarm.intrusion[this.alarm.intrusion.length - 1] += 1
      } else if (water.indexOf(obj.alarmtype) > -1) {
        this.alarm.water[this.alarm.water.length - 1] += 1
      } else if (health.indexOf(obj.alarmtype) > -1) {
        this.alarm.health[this.alarm.health.length - 1] += 1
      } else {
        console.log(obj)
      }
      let vm = this
      setTimeout(() => {
        vm.getAlarmLine()
      }, 100)
    },
    getKindArr () {
      this.dateArr = this.getAlarmDate()
      let date = this.getAlarmDate()
      // console.log('时间', date)
      let alarmData = []
      let arrData = this.alarmLines
      let sos = ['sub_keysos', 'sos', 'nonetwork24', 'outage', 'lowpower', 'phonein', 'remove']
      let smoke = ['nb-co', 'F-Fire', 'F-Test', 'sub_fire', 'sub_co', 'nb-co-test', 'sub_fire_test']
      let gas = ['sub_gas']
      let intrusion = ['sub_infrared', 'sub_opendoor']
      let water = ['sub_water']
      let health = ['heartbeat', 'falldown']
      for (let i = 0; i < arrData.length; i++) {
        let obj = {
          alarmtype: arrData[i].alarmtype,
          alarmtype1: '',
          date: arrData[i].date,
          count: arrData[i].count
        }
        if (sos.indexOf(arrData[i].alarmtype) > -1) {
          obj.alarmtype1 = 'sos'
        } else if (smoke.indexOf(arrData[i].alarmtype) > -1) {
          obj.alarmtype1 = 'smoke'
        } else if (gas.indexOf(arrData[i].alarmtype) > -1) {
          obj.alarmtype1 = 'gas'
        } else if (intrusion.indexOf(arrData[i].alarmtype) > -1) {
          obj.alarmtype1 = 'intrusion'
        } else if (water.indexOf(arrData[i].alarmtype) > -1) {
          obj.alarmtype1 = 'water'
        } else if (health.indexOf(arrData[i].alarmtype) > -1) {
          obj.alarmtype1 = 'health'
        } else {
          console.log(arrData[i])
        }
        if (obj.alarmtype1 !== '') {
          alarmData.push(obj)
        }
      }
      let arr = []
      for (let i = 0; i < alarmData.length; i++) {
        if (date.indexOf(alarmData[i].date) > -1) {
          arr.push(alarmData[i])
        }
      }
      let obj = {}
      for (let i = 0; i < date.length; i++) {
        obj[date[i]] = {
          sos: 0,
          smoke: 0,
          gas: 0,
          intrusion: 0,
          water: 0,
          health: 0
        }
      }
      for (let i = 0; i < arr.length; i++) {
        obj[arr[i].date][arr[i].alarmtype1] = obj[arr[i].date][arr[i].alarmtype1] + parseInt(arr[i].count)
      }
      for (let i = 0; i < date.length; i++) {
        const keys = Object.keys(obj[date[i]])
        for (let j = 0; j < keys.length; j++) {
          this.alarm[keys[j]].push(obj[date[i]][keys[j]])
        }
      }
      let vm = this
      setTimeout(() => {
        vm.getAlarmLine()
      }, 100)
    },
    // 折线图
    getAlarmLine () {
      if (this.alarmLine.length === 0) {
        return
      }
      const line = this.$echarts.init(this.$refs.line_wrap)
      line.setOption({
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['烟感报警', '燃气报警', '水浸报警', '入侵报警', '用户求助', '体征异常'],
          textStyle: {
            color: '#ffffff'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.dateArr,
          axisLine: {
            lineStyle: {
              color: '#7fd4ff',
              width: 1
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#7fd4ff',
              width: 1 // 这里是为了突出显示加上的
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#182f4d',
              width: 1 // 这里是为了突出显示加上的
            }
          }
        },
        series: [
          {
            name: '烟感报警',
            type: 'line',
            stack: '总量',
            smooth: true,
            data: this.alarm.smoke,
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              borderWidth: 3
            }
          },
          {
            name: '燃气报警',
            type: 'line',
            stack: '总量',
            smooth: true,
            data: this.alarm.gas,
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              borderWidth: 3
            }
          },
          {
            name: '水浸报警',
            type: 'line',
            stack: '总量',
            smooth: true,
            data: this.alarm.water,
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              borderWidth: 3
            }
          },
          {
            name: '入侵报警',
            type: 'line',
            stack: '总量',
            smooth: true,
            data: this.alarm.intrusion,
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              borderWidth: 3
            }
          },
          {
            name: '用户求助',
            type: 'line',
            stack: '总量',
            smooth: true,
            data: this.alarm.sos,
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              borderWidth: 3
            }
          },
          {
            name: '体征异常',
            type: 'line',
            stack: '总量',
            smooth: true,
            data: this.alarm.health,
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              borderWidth: 3
            }
          }
        ],
        color: ['#cc003a', '#197519', '#33ffcc', '#ffff33', '#d633ff', 'rgb(255, 168, 0)']
      })
    }
  }
}
</script>

<style scoped>
.line{
  width: 100%;
  height: 100%;
}
.nothing-data{
  height: 100%;
  background: url("../../../assets/monitor/index_nothing.png") center no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/components/monitoring/childComponents/alarmLine.vue